import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  FormGroup,
  FormField,
  Icon,
  TextArea,
  Button
} from 'semantic-ui-react'

const ModMakeAppointmentRehabUX = (props: any) => {
    return(
      <div
        id="ModMakeAppointmentPackageUX-div-0"
        style={{width: "100%"}}>
        <div
          id="ModMakeAppointmentPackageUX-div-1"
          style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "15px 10px 0px 25px", }}>

          <div
            id="ModMakeAppointmentPackageUX-div-3"
            style={{ fontSize: "1.2rem", fontWeight: "bold", }}>
            {props.languageUX === "en" ? "Booking Summary" : "สรุปการจอง"}
          </div>
          <div
            id="ModMakeAppointmentRehabUX-div-64">

            <Icon
              color="red"
              id="ModMakeAppointmentRehabUX-Icon-65"
              link={true}
              name="close"
              onClick={props.onClose}>
            </Icon>
          </div>
        </div>
        <div
          className="ui divider"
          id="ModMakeAppointmentPackageUX-div-2"
          style={{margin: "1rem"}}>

        </div>
        <div
          id="ModMakeAppointmentPackageUX-div-4"
          style={{padding: "0.2rem 2rem 0.25rem", lineHeight: 1.25}}>

          <div
            className="ui form"
            id="ModMakeAppointmentPackageUX-div-5">

            <FormGroup
              id="ModMakeAppointmentPackageUX-FormGroup-6"
              inline={true}>
              <FormField
                id="ModMakeAppointmentPackageUX-FormField-7"
                inline={true}>
                <label
                  id="ModMakeAppointmentPackageUX-label-8"
                  style={{fontSize: "1.1rem", fontWeight: "bold"}}>
                  {props.patientInfo && `${props.patientInfo?.full_name} [${props.patientInfo?.hn}]`}
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="ModMakeAppointmentPackageUX-FormGroup-9"
              inline={true}
              style={{marginLeft: "5px"}}>
              <FormField
                id="ModMakeAppointmentPackageUX-FormField-10"
                inline={true}>
                <div
                  id="ModMakeAppointmentPackageUX-div-18"
                  style={{transform:"scale(1.3)", margin: "0 -0.5rem 0 -0.5rem"}}>

                  <Icon
                    className="blue"
                    id="ModMakeAppointmentPackageUX-Icon-21"
                    name={props.patientInfo?.gender==="M"?"man":props.patientInfo?.gender==="F"?"woman":""}>
                  </Icon>
                  <img
                    id="ModMakeAppointmentRehabUX-img-79"
                    src="/static/images/rehab/unspecified-gender.png"
                    style={{width: "10px", display: props.patientInfo?.gender&& !["M","F"].includes(props.patientInfo?.gender)?"":"none", margin: "0 0.5rem 0 -1.15rem"}}>
                  </img>
                </div>
              </FormField>
              <FormField
                id="ModMakeAppointmentPackageUX-FormField-11"
                inline={true}>
                <label
                  id="ModMakeAppointmentPackageUX-label-16">
                  {props.patientInfo?.birthdate || ""}
                </label>
              </FormField>
              <FormField
                id="ModMakeAppointmentPackageUX-FormField-12"
                inline={true}>
                <div
                  id="ModMakeAppointmentPackageUX-div-19"
                  style={{transform:"rotate(90deg)", margin: "0 -0.5rem 0 0rem"}}>

                  <Icon
                    className="blue"
                    id="ModMakeAppointmentPackageUX-Icon-20"
                    name="phone">
                  </Icon>
                </div>
              </FormField>
              <FormField
                id="ModMakeAppointmentPackageUX-FormField-13"
                inline={true}>
                <label
                  id="ModMakeAppointmentPackageUX-label-17">
                  {props.patientInfo?.present_address?.tel_mobile || "-"}
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="ModMakeAppointmentPackageUX-FormGroup-22"
              inline={true}
              style={{marginTop: "1.5rem"}}>
              <FormField
                id="ModMakeAppointmentPackageUX-FormField-23"
                inline={true}>
                <label
                  id="ModMakeAppointmentPackageUX-label-28"
                  style={{fontSize: "1.1rem", color: "#0072BC"}}>
                  Appointment for
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="ModMakeAppointmentPackageUX-FormGroup-42"
              inline={true}>
              <FormField
                id="ModMakeAppointmentPackageUX-FormField-43"
                inline={true}>
                <div
                  id="ModMakeAppointmentPackageUX-div-44"
                  style={ {lineHeight: 1.75, marginTop: "-0.5rem"}}>
                  {props.rehabNameList}
                </div>
              </FormField>
            </FormGroup>
          </div>
          <div
            className="ui form"
            id="ModMakeAppointmentPackageUX-div-30">

            <FormGroup
              id="ModMakeAppointmentPackageUX-FormGroup-31"
              inline={true}>
              <FormField
                id="ModMakeAppointmentPackageUX-FormField-32"
                inline={true}>
                <label
                  id="ModMakeAppointmentPackageUX-label-33"
                  style={{fontSize: "1.1rem", color: "#0072BC"}}>
                  Appointment date & time
                </label>
              </FormField>
            </FormGroup>
            <FormGroup
              id="ModMakeAppointmentRehabUX-FormGroup-66"
              style={{margin:"-0.25rem 0 0.5rem 0"}}>
              <FormField
                id="ModMakeAppointmentRehabUX-FormField-68"
                style={{display: "flex", padding:0}}>
                <div
                  id="ModMakeAppointmentRehabUX-div-70"
                  style={{fontWeight: "bold"}}>
                  {props.languageUX === "en" ? "Date" : "วันที่"}
                </div>
                <div
                  id="ModMakeAppointmentRehabUX-div-72"
                  style={{fontWeight: "bold", marginLeft: "1rem"}}>
                  {props.appointmentDate || "-"}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="ModMakeAppointmentRehabUX-FormGroup-67">
              <FormField
                id="ModMakeAppointmentRehabUX-FormField-69">
                <div
                  id="ModMakeAppointmentRehabUX-div-71">
                  {props.deviceList}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="ModMakeAppointmentRehabUX-FormGroup-73"
              inline={true}>
              <FormField
                id="ModMakeAppointmentRehabUX-FormField-74"
                inline={true}>
                <div
                  id="ModMakeAppointmentRehabUX-div-75"
                  style={{fontWeight: "bold", color: "rgba(0, 114, 188, 1)"}}>
                  Physiotherapist
                </div>
              </FormField>
              <FormField
                id="ModMakeAppointmentRehabUX-FormField-77">
                <div
                  id="ModMakeAppointmentRehabUX-div-78">
                  {props.physiotherapistSearchBox}
                </div>
              </FormField>
            </FormGroup>
            <FormGroup
              id="ModMakeAppointmentPackageUX-FormGroup-45"
              inline={true}
              style={{marginTop: "1.5rem"}}>
              <FormField
                id="ModMakeAppointmentPackageUX-FormField-48"
                inline={true}>
                <label
                  id="ModMakeAppointmentPackageUX-label-56">
                  {props.languageUX === "en" ? "Additional advice" : "คำแนะนำเพิ่มเติม"}
                </label>
              </FormField>
              <FormField
                id="ModMakeAppointmentPackageUX-FormField-49"
                inline={true}>
                <Button
                  color="blue"
                  id="ModMakeAppointmentPackageUX-Button-57"
                  onClick={props.onAddNote}
                  size="mini">
                  {props.languageUX === "en" ? "ADD" : "เพิ่ม"}
                </Button>
              </FormField>
            </FormGroup>
            <FormGroup
              id="ModMakeAppointmentPackageUX-FormGroup-46"
              inline={true}>
              <FormField
                id="ModMakeAppointmentPackageUX-FormField-51"
                inline={true}
                style={{padding: 0}}
                width={16}>
                <TextArea
                  id="ModMakeAppointmentPackageUX-TextArea-52"
                  onChange={props.onChangeDoctorNote}
                  rows={5}
                  value={props.remark || ""}>
                </TextArea>
              </FormField>
            </FormGroup>
            <FormGroup
              id="ModMakeAppointmentPackageUX-FormGroup-47"
              inline={true}
              style={{marginTop: "2rem"}}>
              <FormField
                id="ModMakeAppointmentPackageUX-FormField-53"
                inline={true}
                style={{flex:1}}>
              </FormField>
              <FormField
                id="ModMakeAppointmentPackageUX-FormField-54"
                inline={true}
                style={{paddingRight: "0", marginTop: "-0.75rem"}}>
                <div
                  id="ModMakeAppointmentPackageUX-div-63">
                  {props.buttonMakeAppointment}
                </div>
              </FormField>
            </FormGroup>
          </div>
        </div>
      </div>
    )
}


export default ModMakeAppointmentRehabUX

export const screenPropsDefault = {"price_claimable":0,"price_non_claimable":0,"price_total":0}

/* Date Time : Fri Aug 22 2025 11:23:18 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"space-between\", alignItems: \"center\", padding: \"15px 10px 0px 25px\", }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui divider"
        },
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"1rem\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "สรุปการจอง",
          "valueEN": "Booking Summary"
        },
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{ fontSize: \"1.2rem\", fontWeight: \"bold\", }"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0.2rem 2rem 0.25rem\", lineHeight: 1.25}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-div-5"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormGroup",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-FormGroup-6"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "FormField",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-FormField-7"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "label",
      "parent": 7,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientInfo && `${props.patientInfo?.full_name} [${props.patientInfo?.hn}]`"
        },
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-label-8"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.1rem\", fontWeight: \"bold\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "FormGroup",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-FormGroup-9"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"5px\"}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "FormField",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-FormField-10"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "FormField",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-FormField-11"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 12,
      "name": "FormField",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-FormField-12"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "FormField",
      "parent": 9,
      "props": {
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-FormField-13"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "label",
      "parent": 11,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientInfo?.birthdate || \"\""
        },
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-label-16"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "label",
      "parent": 13,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientInfo?.present_address?.tel_mobile || \"-\""
        },
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-label-17"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-div-18"
        },
        "style": {
          "type": "code",
          "value": "{transform:\"scale(1.3)\", margin: \"0 -0.5rem 0 -0.5rem\"}"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-div-19"
        },
        "style": {
          "type": "code",
          "value": "{transform:\"rotate(90deg)\", margin: \"0 -0.5rem 0 0rem\"}"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 20,
      "name": "Icon",
      "parent": 19,
      "props": {
        "className": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-Icon-20"
        },
        "name": {
          "type": "value",
          "value": "phone"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "Icon",
      "parent": 18,
      "props": {
        "className": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-Icon-21"
        },
        "name": {
          "type": "code",
          "value": "props.patientInfo?.gender===\"M\"?\"man\":props.patientInfo?.gender===\"F\"?\"woman\":\"\""
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "FormGroup",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-FormGroup-22"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"1.5rem\"}"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "FormField",
      "parent": 22,
      "props": {
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-FormField-23"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "label",
      "parent": 23,
      "props": {
        "children": {
          "type": "value",
          "value": "Appointment for "
        },
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-label-28"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.1rem\", color: \"#0072BC\"}"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-div-30"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "FormGroup",
      "parent": 30,
      "props": {
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-FormGroup-31"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "FormField",
      "parent": 31,
      "props": {
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-FormField-32"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": null,
      "id": 33,
      "name": "label",
      "parent": 32,
      "props": {
        "children": {
          "type": "value",
          "value": "Appointment date & time "
        },
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-label-33"
        },
        "style": {
          "type": "code",
          "value": "{fontSize: \"1.1rem\", color: \"#0072BC\"}"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 42,
      "name": "FormGroup",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-FormGroup-42"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "FormField",
      "parent": 42,
      "props": {
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-FormField-43"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": null,
      "id": 44,
      "name": "div",
      "parent": 43,
      "props": {
        "children": {
          "type": "code",
          "value": "props.rehabNameList"
        },
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-div-44"
        },
        "style": {
          "type": "code",
          "value": " {lineHeight: 1.75, marginTop: \"-0.5rem\"}"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 45,
      "name": "FormGroup",
      "parent": 30,
      "props": {
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-FormGroup-45"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"1.5rem\"}"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 46,
      "name": "FormGroup",
      "parent": 30,
      "props": {
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-FormGroup-46"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 47,
      "name": "FormGroup",
      "parent": 30,
      "props": {
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-FormGroup-47"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"2rem\"}"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 48,
      "name": "FormField",
      "parent": 45,
      "props": {
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-FormField-48"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 49,
      "name": "FormField",
      "parent": 45,
      "props": {
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-FormField-49"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 51,
      "name": "FormField",
      "parent": 46,
      "props": {
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-FormField-51"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{padding: 0}"
        },
        "width": {
          "type": "code",
          "value": "16"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 52,
      "name": "TextArea",
      "parent": 51,
      "props": {
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-TextArea-52"
        },
        "name": {
          "type": "value",
          "value": ""
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeDoctorNote"
        },
        "rows": {
          "type": "code",
          "value": "5"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "value": {
          "type": "code",
          "value": "props.remark || \"\""
        }
      },
      "seq": 52,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 53,
      "name": "FormField",
      "parent": 47,
      "props": {
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-FormField-53"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "FormField",
      "parent": 47,
      "props": {
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-FormField-54"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{paddingRight: \"0\", marginTop: \"-0.75rem\"}"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": null,
      "id": 56,
      "name": "label",
      "parent": 48,
      "props": {
        "children": {
          "type": "value",
          "value": "คำแนะนำเพิ่มเติม",
          "valueEN": "Additional advice"
        },
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-label-56"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 57,
      "name": "Button",
      "parent": 49,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่ม",
          "valueEN": "ADD"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-Button-57"
        },
        "onClick": {
          "type": "code",
          "value": "props.onAddNote"
        },
        "size": {
          "type": "value",
          "value": "mini"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": null,
      "id": 63,
      "name": "div",
      "parent": 54,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonMakeAppointment"
        },
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentPackageUX-div-63"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": null,
      "id": 64,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentRehabUX-div-64"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 65,
      "name": "Icon",
      "parent": 64,
      "props": {
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentRehabUX-Icon-65"
        },
        "link": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "close"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClose"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 66,
      "name": "FormGroup",
      "parent": 30,
      "props": {
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentRehabUX-FormGroup-66"
        },
        "style": {
          "type": "code",
          "value": "{margin:\"-0.25rem 0 0.5rem 0\"}"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 67,
      "name": "FormGroup",
      "parent": 30,
      "props": {
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentRehabUX-FormGroup-67"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 68,
      "name": "FormField",
      "parent": 66,
      "props": {
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentRehabUX-FormField-68"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", padding:0}"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 69,
      "name": "FormField",
      "parent": 67,
      "props": {
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentRehabUX-FormField-69"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": null,
      "id": 70,
      "name": "div",
      "parent": 68,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่",
          "valueEN": "Date"
        },
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentRehabUX-div-70"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": null,
      "id": 71,
      "name": "div",
      "parent": 69,
      "props": {
        "children": {
          "type": "code",
          "value": "props.deviceList"
        },
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentRehabUX-div-71"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": null,
      "id": 72,
      "name": "div",
      "parent": 68,
      "props": {
        "children": {
          "type": "code",
          "value": "props.appointmentDate || \"-\""
        },
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentRehabUX-div-72"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginLeft: \"1rem\"}"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 73,
      "name": "FormGroup",
      "parent": 30,
      "props": {
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentRehabUX-FormGroup-73"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 74,
      "name": "FormField",
      "parent": 73,
      "props": {
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentRehabUX-FormField-74"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": null,
      "id": 75,
      "name": "div",
      "parent": 74,
      "props": {
        "children": {
          "type": "value",
          "value": "Physiotherapist "
        },
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentRehabUX-div-75"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", color: \"rgba(0, 114, 188, 1)\"}"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 77,
      "name": "FormField",
      "parent": 73,
      "props": {
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentRehabUX-FormField-77"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": null,
      "id": 78,
      "name": "div",
      "parent": 77,
      "props": {
        "children": {
          "type": "code",
          "value": "props.physiotherapistSearchBox"
        },
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentRehabUX-div-78"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": null,
      "id": 79,
      "name": "img",
      "parent": 18,
      "props": {
        "id": {
          "type": "value",
          "value": "ModMakeAppointmentRehabUX-img-79"
        },
        "src": {
          "type": "value",
          "value": "/static/images/rehab/unspecified-gender.png"
        },
        "style": {
          "type": "code",
          "value": "{width: \"10px\", display: props.patientInfo?.gender&& ![\"M\",\"F\"].includes(props.patientInfo?.gender)?\"\":\"none\", margin: \"0 0.5rem 0 -1.15rem\"}"
        }
      },
      "seq": 79,
      "void": true
    }
  ],
  "forwardRef": false,
  "height": 90,
  "isMounted": false,
  "memo": false,
  "name": "ModMakeAppointmentRehabUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "price_claimable": 0,
    "price_non_claimable": 0,
    "price_total": 0
  },
  "width": 55
}

*********************************************************************************** */
